import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import App from './App.vue'
import router from './router'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

import { usePortAllData } from './stores/portAllData'

import GeomodMap from './plugins/GeomodMap.js'
import connectMessaging from './plugins/GeomodMessaging.js'
import './assets/main.scss'

const app = createApp(App)
const _locale = localStorage.getItem('locale') || 'en';

const i18n = createI18n({
  legacy: false,
  locale: _locale,
  fallbackLocale: 'en'
})

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(Vue3Toastify, {
  autoClose: 1500,
  position: toast.POSITION.BOTTOM_CENTER,
  toastClassName: 'toast-container'
})
app.component('GenericDataTable', Vue3EasyDataTable)

const store = usePortAllData()

const serverUrl = import.meta.env.VITE_SERVER_URL || 'http://localhost:3001'
// const javaserver = import.meta.env.VITE_JAVASERVER === 'true' || false
const websocketUrl = `${serverUrl.replace('http', 'ws')}/state`
fetch(`${serverUrl}/appConfig`)
  .then(resp => resp.json())
  .then(config => {
    const mapParams = {
      sourceUrl: serverUrl,
      map: { ...config.map },
      defaultExtraParameters: { ...config.defaultExtraParameters },
      controls: { ...config.controls }
    }

    const map = new GeomodMap(mapParams)
    let socket
    if (websocketUrl) socket = connectMessaging(websocketUrl)
    config.server_url = serverUrl
    localStorage.setItem('config', JSON.stringify(config))

    app.provide('$map', map)
    app.provide('$config', config)
    app.provide('$socket', socket)
    app.mount('#app')
  })
